import AllSalesContainer from './all-sales-container';

export default AllSalesContainer;
